import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import { useSubscription } from '../contexts/SubscriptionContext';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const { t, locale, setLocale } = useLocale();
  const { hasAccess } = useSubscription();
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { to: '/', label: t.nav.home, end: true },
    { to: '/streams', label: t.nav.streams },
    { to: '/news', label: t.nav.news }
    // Scores temporarily hidden — route /scores still exists
  ];

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="vf-header">
      <div className="vf-header__inner">
        <button
          type="button"
          className="vf-wordmark"
          onClick={() => {
            closeMenu();
            navigate('/');
          }}
          aria-label={t.brand}
        >
          <img
            src="/logo-wordmark.webp?v=2"
            alt="Live Football"
            className="vf-wordmark__logo"
            height="40"
            fetchPriority="high"
            decoding="async"
          />
        </button>

        <nav className={`vf-nav${menuOpen ? ' is-open' : ''}`} aria-label="Main">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `vf-nav__link${isActive ? ' is-active' : ''}`}
              onClick={closeMenu}
            >
              {item.label}
            </NavLink>
          ))}

          {hasAccess && (
            <div className="vf-nav__auth vf-nav__auth--mobile">
              <NavLink to="/account" className="vf-nav__link" onClick={closeMenu}>
                {t.nav.account}
              </NavLink>
            </div>
          )}
        </nav>

        <div className="vf-header__tools">
          {hasAccess && (
            <div className="vf-nav__auth vf-nav__auth--desktop">
              <NavLink to="/account" className="vf-account-chip">
                <span className="vf-account-chip__label">{t.nav.account}</span>
              </NavLink>
            </div>
          )}

          <div className="vf-lang" role="group" aria-label="Language">
            <button
              type="button"
              className={locale === 'en' ? 'is-active' : ''}
              onClick={() => setLocale('en')}
            >
              EN
            </button>
            <button
              type="button"
              className={locale === 'pt' ? 'is-active' : ''}
              onClick={() => setLocale('pt')}
            >
              PT
            </button>
          </div>

          <button
            type="button"
            className={`vf-burger${menuOpen ? ' is-open' : ''}`}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
